export default __webpack_public_path__ + "static/media/487.a1894de4.png";